import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export const getCountdownInterval = (referenceDate: string, format?: dayjs.OptionType) => {
  const now = dayjs();
  const then = dayjs(referenceDate, format);
  const interval = dayjs.duration(then.diff(now, 'millisecond', true));

  return {
    hours: interval.hours(),
    minutes: interval.minutes(),
    seconds: interval.seconds(),
    days: interval.days(),
    months: interval.months(),
    years: interval.years(),
    then,
    now,
  };
};
